import { useState, useEffect } from 'react'

import Api from 'services/api'

import { DeviceConsolidatedEvent } from 'types/ConsolidatedEvent'

const useDeviceConsolidatedEvents = (deviceId, date) => {
  const [consolidatedEvents, setConsolidatedEvents] = useState<Array<DeviceConsolidatedEvent> | null>(null)
  const [areConsolidatedEventsLoaded, setAreConsolidatedEventsLoaded] = useState(false)

  useEffect(() => {
    setConsolidatedEvents(null)
    setAreConsolidatedEventsLoaded(false)

    if (!deviceId || !date) return

    Api.ConsolidatedEvents.get(deviceId, date)
      .then((res) => {
        if (res.consolidatedEvents) {
          setAreConsolidatedEventsLoaded(true)
          setConsolidatedEvents(res.consolidatedEvents)
        }
      })
      .catch(() => {
        setAreConsolidatedEventsLoaded(true)
        setConsolidatedEvents(null)
      })
  }, [deviceId, date])

  return { consolidatedEvents, areConsolidatedEventsLoaded }
}

export default useDeviceConsolidatedEvents
